import React, {useContext} from "react";
import {apiGet, apiPost} from "../../core/api";
import axios from "axios";
import Consts from "../../core/consts";
import Status from "../../core/status";
import {MaxBtn} from "../../core/components";
import {FormContext} from "../../core/form_context";
import {FaFile, FaFileAudio} from "react-icons/fa";
import {TextfieldInput} from "../../core/input_fields";
import {maxiPost} from "../../core/maxios";

export default function DocumentR({content, editMode, data, ...rest}) {
    const context = useContext(FormContext);
    const setFileData = (data) => {
        context.setState({block: {...context.state.block, data}});
    };
    return <div>
        {
            !!data &&
            <a
                href={"https://vereinfacht-public.s3-eu-west-1.amazonaws.com/" + data.fileToken}
                target={"_blank"}
                className={"blockFile"}>
                {
                    {
                        "pdf": <FaFile style={{fontSize: "60px"}}/>,
                        "mp3": <FaFileAudio style={{fontSize: "60px"}}/>
                    } [data.type] || <FaFile style={{fontSize: "60px"}}/>
                }
                <div>
                    {content} {!!data.type && false && `(${data.type})`}
                </div>
            </a>
        }
        {editMode && <>
            <TextfieldInput name={"Name"} tag={"block_content"} style={{width: "200px"}}/>
            <UploadDocument setFileData={setFileData} slot={rest.slot}/>

        </>}
    </div>

}

class UploadDocument extends React.Component {
    constructor(props,) {
        super(props);
        this.apiGet = apiGet.bind(this);
        this.apiPost = apiPost.bind(this);
        this.setState = this.setState.bind(this);
        this.fileField = React.createRef();

        this.state = {
            showing: 1,
            loading: false,
            progress: 100,

        };
    }

    saveFile = (close) => (e) => {
        e.preventDefault();
        this.setState({loading: true});

        var formData = new FormData();
        formData.append("document", this.fileField.current.files[0]);
        formData.append("slot", this.props.slot);
        axios.post(Consts.API_PREFIX + "/page_blocks/document/upload", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: progressEvent => {
                this.setState({
                    progress: Math.round(progressEvent.loaded / progressEvent.totalSize * 100)
                })
            }
        })
            .then(response => {
                if (response.data.status === "error") {
                    this.setState({
                        error: response.data.message,
                        status: "",
                        loading: false
                    })
                } else {
                    this.props.setFileData(response.data)
                    this.setState({
                        status: response.data.message,
                        error: "",
                        [this.fieldName]: response.data.file_name,
                        loading: false, renew: false
                    });
                }
            })
            .catch((error) => {
                console.log("error", error);
                //this.setState({loading: false})
                this.setState({
                    error: error.message,
                    loading: false,
                    status: ""
                })
            });
    };
    handleChange = (e) => {

        const s = e.target.name.split("_");
        this.setState({
            [s[0]]: Object.assign(
                {},
                this.state[s[0]],
                {[s[1]]: e.target.type === 'checkbox' ? e.target.checked : e.target.value}
            )
        });

    };

    handleSubmit = (event) => {
        event.preventDefault();
    };

    render() {

        return <>
            <Status type={"error"} text={this.state.error}/>
            <form id={"profile_picture_form"} onChange={this.handleChange} onSubmit={this.handleSubmit}>
                <div id="excel_file">
                    <label>
            <span>
            Dokument (PDF, MP3)
            </span>
                        <input
                            style={{paddingTop: "20px"}}
                            type={"file"}
                            ref={this.fileField}
                        />
                        {this.state.loading &&
                        <label>
                            <img alt={"loader"}
                                 src="https://uid-suche.eu/src/img/ajax-loader-fff.gif"/> {this.state.progress} % {this.state.progress === 100 &&
                        <span>(verarbeite Dokument)</span>}
                        </label>
                        }
                    </label>
                    <MaxBtn onClick={this.saveFile(() => {
                    })}>Datei uploaden</MaxBtn>
                </div>
            </form>
        </>

    }
}
